import(/* webpackMode: "eager" */ "/codebuild/output/src2540224303/src/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["CurrencyPreferencePrompt"] */ "/codebuild/output/src2540224303/src/app/src/v2/containers/CurrencyPicker/CurrencyPreferencePrompt.tsx");
